////////////////////////////////////////////////////////////////////////////////
// Copyright 2019 Federated Wireless.
//
// GOVERNMENT PURPOSE RIGHTS
//
// Contractor Name:    Federated Wireless
// Contractor Address: 3865 Wilson Blvd, Arlington, VA 22203
//
// The Government's rights to use, modify, reproduce, release, perform, display,
// or disclose this software are restricted by paragraph (b)(2) of the Rights in
// Noncommercial Computer Software and Noncommercial Computer Software
// Documentation clause contained in the 7013 Clause. Any reproduction of the
// software or portions thereof marked with this legend must also reproduce the
// markings.
// This source code delivery is exclusively for Government Purposes pertaining
// to this program; no commercial use. The Computer Software Configuration
// Items were delivered for only the purposes spelled out by the contract
// delivered under.
//
// Export Warning - The technical data in this document (or file) is
// controlled for export under the International Traffic in Arms Regulations
// (ITAR), 22CFR 120-130.  Violations of these export laws may be subject to
// fines and penalties under the Arms Export Control Act (22 U.S.C. 2778).
//
////////////////////////////////////////////////////////////////////////////////
//
// Security Classification: UNCLASSIFIED
//
////////////////////////////////////////////////////////////////////////////////

const stringContainsPositiveIntegerRegex = /^(\+|-)?[0-9][\d]*$/
const telephoneRegex = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/
const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const postcodeRegex = /\b((?:(?:gir)|(?:[a-pr-uwyz])(?:(?:[0-9](?:[a-hjkpstuw]|[0-9])?)|(?:[a-hk-y][0-9](?:[0-9]|[abehmnprv-y])?)))) ?([0-9][abd-hjlnp-uw-z]{2})\b/i

const validateIntegerRange = (value, lower, upper, value_name, errors) => {
  if (!value) {
    errors[value_name] = 'Required'
  } else if (isNaN(value) || !stringContainsPositiveIntegerRegex.test(value)) {
    errors[value_name] = 'Must an integer'
  } else if (parseInt(value)>upper || parseInt(value)<lower){
    errors[value_name] = `Must be between ${lower} and ${upper}`
  }
}

const validate = values => {

    const errors = {}
    for (let field of ["existingcustomer","customernumber","entity","name","companyname","companyregnumber","charityname","charityregnumber","legalentityname","regnumber"]){
        if (!values[field] || values[field].trim().length === 0) {
            errors[field] = 'Required'
        }

    }
    for (let fieldname of ["licenceename","licenceeaddress","licenceepostcode","licenceecountry","telephone","email"]){
        for (let fieldsuffix of ["","3","4","5"]){
            let field = `${fieldname}${fieldsuffix}`
            if (!values[field] || values[field].trim().length === 0) {
                errors[field] = 'Required'
            }
        }
    }
    
    for (let fieldname of ['telephone', 'mobile', 'fax', 'email', 'licenceepostcode']) {
      for (let fieldsuffix of ['','3','4','5']) {
        let field = `${fieldname}${fieldsuffix}`

        if (!values[field])
          continue

        if ((field.startsWith('telephone') ||
             field.startsWith('mobile') ||
             field.startsWith('fax')) && 
            !telephoneRegex.test(values[field].trim())) {
          errors[field] = 'Invalid telephone number'
        }

        if (field.startsWith('email') &&
            !emailRegex.test(values[field].trim())) {
          errors[field] = 'Invalid email address'
        }

        if (field.startsWith('licenceepostcode') &&
            !postcodeRegex.test(values[field].trim())) {
          errors[field] = 'Invalid postcode'
        }
      }
    }
    return errors
  }
  
  export default validate
  